module.exports = __webpack_public_path__ + "media/images/education/cover-2a6efbfced374ed451e06557ab035e98.png";